import { render, staticRenderFns } from "./AdvantageCard.vue?vue&type=template&id=7a10bba5&scoped=true&"
import script from "./AdvantageCard.vue?vue&type=script&lang=js&"
export * from "./AdvantageCard.vue?vue&type=script&lang=js&"
import style0 from "./AdvantageCard.vue?vue&type=style&index=0&id=7a10bba5&prod&lang=scss&scoped=true&"
import style1 from "./AdvantageCard.vue?vue&type=style&index=1&id=7a10bba5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10bba5",
  null
  
)

export default component.exports